export const name = 're-shop-product-field-booking-slot-selector'

import props from './props'
import ComponentMixin from '../../../../../../mixins/components/complex-reactive'
const mixins = [ComponentMixin]

export {props, mixins}

export const EventBus = window.VueEventBus

// data
const propDefs = props
export const data = {
  propDefs,
}

export default {
  name,
  mixins,
  props,
  data,
  EventBus,
}
